import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'images'
const verb = HttpMethod.DELETE

export default class OspreyImagesRemoveFromAffiliationsShare extends BaseAction {
    constructor(dataKey) {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d425b1'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    removeFromAffiliationsShare(params) {
        const { imageId, affiliationIdList } = params

        this.path = `/${resource}/${imageId}/share/affiliations`

        this.params = {
            affiliationIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-affiliations-remove.js